<template>
  <div class="recharge_container">
    <div class="recharge_type">
      <p>选择充值金额</p>
      <div class="amount_select">
        <div
          v-for="(item, index) in amount"
          :key="index"
          class="amount_size"
          :class="isAmount == index ? 'select_bg' : 'no_bg'"
          @click="selectClick(index, item)"
        >
          <span :class="isPrefer ? 'preferential' : 'no_preferential'"
            >充{{ item.price }}元</span
          >
          <span v-if="isPrefer">充{{ item.price / 2 }}元</span>
          <br />
          <span>(得{{ item.duration }}分钟)</span>
        </div>
      </div>
      <div class="field_pre">
        <mt-field
          label="优惠卡卡号"
          placeholder="请输入卡号"
          v-model="preferential"
        ></mt-field>
        <mt-button type="primary" @click="verifyTest()" class="verify_test"
          >验证</mt-button
        >
      </div>
      <div class="pay_type">
        <p>选择支付方式</p>
        <div class="is_wx">
          <mt-radio align="right" v-model="value" :options="options"></mt-radio>
        </div>
        <p class="desc">1.以上充值学时为模拟器专属使用;</p>
        <p class="desc">2.支付/充值费用转化为学时虚拟课程，一旦购买，不支持退款;</p>
      </div>
      <mt-button type="primary" class="submit_bg" @click="payHandle">立即支付</mt-button>
    </div>
  </div>
</template>
<script>
import _wx from "../../static/js/chelun-wx-1.1.js";
import URL from "../../static/js/url.js";
import { simulatorPay, getPrice, simulatorChekCard } from "@/http/api";
import { encrypt } from "@/util/md5";
import { Toast } from "mint-ui";

export default {
  data() {
    return {
      openid: "",
      public_path: process.env.PUBLICK_PATH,
      isAmount: 0,
      value: "0",
      amount: [],
      options: [
        {
          label: "微信",
          value: "0",
        },
      ],
      studentDuration: 0,
      totalAmount: 0,
      dev_sn: "",
      preferential: "",
      isPrefer: false,
    };
  },
  created() {
    this.openid = URL.getQueryString("openid");
    this.dev_sn = URL.getQueryString("dev_sn");
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      const timestamp = Date.parse(new Date()) / 1000;
      const str = this.openid + timestamp.toString() + "TY20230618";
      const data = {
        open_id: this.openid,
        timestamp: timestamp,
        sign: encrypt(str),
      };
      getPrice(data).then((res) => {
        if (res.code == 0) {
          this.studentDuration = res.data[0].duration;
          this.totalAmount = res.data[0].price;
          this.amount = res.data;
        }
      });
    },
    payHandle() {
      if (this.isPrefer) {
        this.totalAmount = this.totalAmount / 2;
      }
      let data = {
        open_id: this.openid,
        amount: this.totalAmount,
        student_duration: this.studentDuration,
        dev_sn: this.dev_sn,
        pay_type: this.value, // 微信 0  支付宝 1
      };
      simulatorPay(data).then((res) => {
        console.log(res);
        this.onBridgeReady(res.data);
      });
    },

    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号ID，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: "RSA", //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            window.location.href = `${window.$root.$requestEnv.hostUrl}/h5/simulator-home`;
          }
        }
      );
    },

    selectClick(index, value) {
      this.isAmount = index;
      this.studentDuration = value.duration;
      this.totalAmount = value.price;
    },
    verifyTest() {
      if (!this.preferential) {
        Toast({
          message: "请输入优惠卡号",
          position: "center",
          duration: 2000,
        });
        return;
      }
      const timestamp = Date.parse(new Date()) / 1000;
      const str = this.openid + timestamp.toString() + "TY20230618";
      const data = {
        card_no: this.preferential,
        open_id: this.openid,
        timestamp: timestamp,
        sign: encrypt(str),
      };
      simulatorChekCard(data).then((res) => {
        if (res.code == 0) {
          this.isPrefer = true;
        } else {
          this.isPrefer = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge_container {
  color: #333;
  .recharge_type {
    margin-top: 20px;
    padding: 18px;
    font-size: 18px;
    font-weight: 500;
    .amount_select {
      display: flex;
      margin-top: 10px;
      .amount_size {
        flex: 1;
        padding: 16px 0px;
        border: 0.5px solid rgba(0, 0, 0, 0.3);
        text-align: center;
        border-radius: 4px;
        .preferential {
          text-decoration: line-through;
          font-size: 12px;
        }
      }
      .amount_size:last-child {
        margin-left: 16px;
      }
      .select_bg {
        background-color: #02b389;
        border: 1px solid #02b389;
        color: #fff;
      }
      .no_bg {
        background-color: #fff;
        border: 1px solid #ccc;
      }
    }
    .pay_type {
      margin-top: 24px;
      .is_wx {
        margin-top: 10px;
        margin-bottom: 15px;
      }
    }
    .desc {
      margin-top: 8px;
      font-size: 12px;
    }
    .submit_bg {
      margin-top: 20px;
      background-color: #02b389;
      border: #02b389;
      width: 100%;
    }
  }
  .field_pre {
    display: flex;
    margin-top: 10px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .verify_test {
      background-color: #02b389;
      border: #02b389;
      padding: 0;
      width: 60px;
      margin-top: 3px;
    }
  }
  .mint-radiolist ::v-deep {
    .mint-cell-wrapper {
      border-bottom: 0.5px solid #ccc !important;
      padding: 0px !important;
    }
  }
  .mint-field ::v-deep {
    .mint-cell-wrapper {
      padding: 0px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/simulator-pay.vue